import { createSlice } from "@reduxjs/toolkit";

const initialHomeworksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  students: [],
  homework: {}
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const homeworkSlice = createSlice({
  name: "homeworks",
  initialState: initialHomeworksState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getHomeworks
    homeworksFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getAllList
    allListFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachers = entity.teachers;
      state.sections = entity.sections;
      state.courses = entity.courses;
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachers = entity.teachers;
      state.courses = entity.courses;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.students = entities;
    },
    // getHomework
    homeworkFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;      
      state.homework = entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanStudentsState
    studentsStateCleaned: (state) => {
      state.students = [];
    },
    // cleanHomework
    homeworkStateCleaned: (state) => {
      state.homework = {};
    },
    // cleanHomeworksState
    homeworksStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});